export default function CssFilterLogoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 44 21">
      <defs>
        <marker orient="auto" overflow="visible" refX="0" refY="0">
          <path
            fill="#000"
            fillOpacity="1"
            fillRule="evenodd"
            stroke="#000"
            strokeOpacity="1"
            strokeWidth=".8pt"
            d="M4.616 0l-6.92 4v-8z"
          />
        </marker>
        <marker orient="auto" overflow="visible" refX="0" refY="0">
          <path
            fill="#a1a1a1"
            fillOpacity="1"
            fillRule="evenodd"
            stroke="#a1a1a1"
            strokeOpacity="1"
            strokeWidth=".8pt"
            d="M-4.616 0l6.92-4v8z"
          />
        </marker>
        <marker id="marker1763" orient="auto" overflow="visible" refX="0" refY="0">
          <path
            fill="#a1a1a1"
            fillOpacity="1"
            fillRule="evenodd"
            stroke="#a1a1a1"
            strokeOpacity="1"
            strokeWidth=".8pt"
            d="M-4.616 0l6.92-4v8z"
          />
        </marker>
        <marker orient="auto" overflow="visible" refX="0" refY="0">
          <path
            fill="#000"
            fillOpacity="1"
            fillRule="evenodd"
            stroke="#000"
            strokeOpacity="1"
            strokeWidth=".8pt"
            d="M10 0l4-4L0 0l14 4z"
          />
        </marker>
        <path d="M198.047 -13.096H237.87V67.085H198.047z" />
        <path d="M-14.363 48.381H57.83V80.887H-14.363z" />
        <path d="M94.346 72.965H182.01V84.19H94.346z" />
        <path d="M-21.382 74.034H180.13899999999998V168.647H-21.382z" />
        <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
        <path d="M16.631 99.786H281.006V158.796H16.631z" />
        <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
        <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
        <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
        <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
        <marker orient="auto" overflow="visible" refX="0" refY="0">
          <path
            fill="#a1a1a1"
            fillOpacity="1"
            fillRule="evenodd"
            stroke="#a1a1a1"
            strokeOpacity="1"
            strokeWidth=".8pt"
            d="M-4.616 0l6.92-4v8z"
          />
        </marker>
        <filter width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
          <feGaussianBlur stdDeviation="0" />
        </filter>
        <marker id="marker1763-5" orient="auto" overflow="visible" refX="0" refY="0">
          <path
            fill="#3b3f62"
            fillOpacity="1"
            fillRule="evenodd"
            stroke="#3b3f62"
            strokeOpacity="1"
            strokeWidth=".8pt"
            d="M-4.616 0l6.92-4v8z"
          />
        </marker>
        <path d="M16.631 99.786H281.006V158.796H16.631z" />
        <path d="M16.631 99.786H281.006V158.796H16.631z" />
        <filter width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
          <feGaussianBlur stdDeviation="0" />
        </filter>
        <path d="M16.631 99.786H281.006V158.796H16.631z" />
        <path d="M16.631 99.786H281.006V158.796H16.631z" />
        <filter width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
          <feGaussianBlur stdDeviation="0" />
        </filter>
      </defs>
      <g strokeDasharray="none" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="4" strokeOpacity="1">
        <path fill="none" stroke="#989ba0" strokeWidth="4.382" d="M27.819 14.052H9.146" />
        <path fill="none" stroke="#779edc" strokeWidth="4.265" d="M31.415 10.582H12.63" />
        <path fill="#3b3f62" fillOpacity="1" stroke="#3b3f62" strokeWidth="4.287" d="M33.602 7.021H16.035" />
        <path
          fill="none"
          stroke="#a1a1a1"
          strokeWidth="1.06"
          markerStart="url(#marker1763)"
          d="M7.51 14.125v0l1.636-.073"
        />
        <path
          fill="#3b3f62"
          fillOpacity="1"
          stroke="#3b3f62"
          strokeWidth="1.06"
          markerStart="url(#marker1763-5)"
          d="M36.107 6.936h-2.505l4.14-.072"
        />
      </g>
    </svg>
  );
}
